import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/login";
import Logout from "../pages/logout";
import NotAllowed from "../pages/notAllowed";
import Recovery from "../pages/recovery";
import AdministrativeChange from "../pages/administrativeChange";
import { AuthProvider } from "../context/authContext";

function Router({systemData}) {
  return (
    <BrowserRouter basename={`${process.env.REACT_APP_BASENAME}`}>
      <AuthProvider>
        <Routes>
          <Route path="*" element={<Login systemData={systemData} />} />
          <Route path="/" element={<Login systemData={systemData} />} />
          <Route path="/login" element={<Login systemData={systemData} />} />
          <Route path="/recuperarcontrasena" element={<Recovery systemData={systemData} />} />
          <Route path="/administrativechangepassword" element={<AdministrativeChange systemData={systemData} />} />
          <Route path="/notAllowed" element={<NotAllowed systemData={systemData} />} />
          <Route path="/logout" element={<Logout />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default Router;
